export const PrimaryColor = '#014d98';
export const PrimaryHoverColor = '#00326C';
export const SecondaryColor = '#C6CACE';
export const SecondaryHovercolor = '#C6CACE';
export const HeaderTextColor = '#00326C';
export const FocusTextColor = '#676D72';
export const DefaultTextColor = '#878795';
export const MenuTextColor = '#4B5056';
export const LinkTextColor = '#37AEFD';
export const LinkHoverTextColor = '#015DB1';